export const bisectLeft = (data: Record<string, unknown>[], key: string, target: number) => {
  let low = 0;
  let high = data.length;
  while (low < high) {
    const middle = (low + high) >>> 1;
    if ((data[middle][key] as number) < target) low = middle + 1;
    else high = middle;
  }
  return low;
};
